import { render, staticRenderFns } from "./enCourseCreOrd.vue?vue&type=template&id=37745ba3&scoped=true&"
import script from "./enCourseCreOrd.vue?vue&type=script&lang=js&"
export * from "./enCourseCreOrd.vue?vue&type=script&lang=js&"
import style0 from "./enCourseCreOrd.vue?vue&type=style&index=0&id=37745ba3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37745ba3",
  null
  
)

export default component.exports